module.exports = __webpack_public_path__ + "img/erudio_maos.cdf03576.svg";